<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16">
  <path
    d="M3.35 13.393A8 8 0 0 1 0 6.883V3l7-3 7 3v3.883a8.002 8.002 0 0 1-3.35 6.51L7 16l-3.65-2.607ZM6 12.828l1 .714 1-.714V2.605l-1-.43-1 .43v10.223Z"
    fill="#808080"
    data-player="true"
  />
  <path
    d="m7 13.542 1-.714V2.605l-1-.43-1 .43v10.223l1 .714Z"
    fill="#aaaaaa"
    data-player="true"
  />
</svg>
